/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Body_add_your_food_api_v1_meals_your_food_post = {
  url?: string | null;
  image_url?: string | null;
  image?: Blob | null;
  food_image?: Blob | null;
  free_text?: string | null;
  ingredients?: string | null;
  portion_size?: number | null;
  instructions?: string | null;
  recipe_name?: string | null;
  from_onboarding?: boolean | null;
  meal_time: Body_add_your_food_api_v1_meals_your_food_post.meal_time;
};
export namespace Body_add_your_food_api_v1_meals_your_food_post {
  export enum meal_time {
    BREAKFAST = "breakfast",
    LUNCH = "lunch",
    DINNER = "dinner",
    SNACK = "snack",
  }
}
